import React from 'react';
import './BlackberrySpecialDesignCategory.scss';

const BlackberrySpecialDesignCategory = () => {
  // Sample category data - replace with actual data from props or API
  const categories = [
    {
      id: 1,
      name: 'Sarees',
      image: '/assets/img/elnora/A.png',
      alt: 'Traditional Indian Sarees'
    },
    {
      id: 2,
      name: 'Lehengas',
      image: '/assets/img/elnora/B.png',
      alt: 'Designer Lehengas'
    },
    {
      id: 3,
      name: 'Kurtis',
      image: '/assets/img/elnora/C.png',
      alt: 'Ethnic Kurtis'
    },
    {
      id: 4,
      name: 'Salwar Suits',
      image: '/assets/img/elnora/D.png',
      alt: 'Traditional Salwar Suits'
    },
    {
      id: 5,
      name: 'Anarkalis',
      image: '/assets/img/elnora/E.png',
      alt: 'Elegant Anarkali Dresses'
    },
    {
      id: 6,
      name: 'Indo-Western',
      image: '/assets/img/elnora/F.png',
      alt: 'Indo-Western Outfits'
    },
    {
      id: 7,
      name: 'Dupattas',
      image: '/assets/img/elnora/G.png',
      alt: 'Designer Dupattas'
    },
    {
      id: 8,
      name: 'Palazzo Sets',
      image: '/assets/img/elnora/I.png',
      alt: 'Palazzo Sets'
    },
    {
      id: 9,
      name: 'Sharara Sets',
      image: '/assets/img/elnora/J.png',
      alt: 'Sharara Sets'
    }
  ];

  const handleCategoryClick = (categoryId, categoryName) => {
    // Handle category navigation
    console.log(`Navigating to ${categoryName} category with ID: ${categoryId}`);
    // Add your navigation logic here
  };

  return (
    <section className="bb-special-design-category">
      <div className="bb-special-design-category-container">
        <div className="bb-special-design-category-header">
          <h2 className="bb-special-design-category-title">Elegance in Every Collection</h2>
          {/* <p className="bb-special-design-category-subtitle">Discover our exclusive collection of ethnic wear</p> */}
        </div>
        
        <div className="bb-special-design-category-grid">
          {categories.map((category) => (
            <div 
              key={category.id} 
              className="bb-special-design-category-item"
              onClick={() => handleCategoryClick(category.id, category.name)}
            >
              <div className="bb-special-design-category-image-wrapper">
                <img 
                  src={category.image} 
                  alt={category.alt}
                  className="bb-special-design-category-image"
                  loading="lazy"
                />
                <div className="bb-special-design-category-overlay">
                  <span className="bb-special-design-category-overlay-text">Shop Now</span>
                </div>
              </div>
              <div className="bb-special-design-category-info">
                <h3 className="bb-special-design-category-name">{category.name}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlackberrySpecialDesignCategory;
